import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { BaseController } from '../../../core/abstractions/base.controller';
import { ListTransactionModel } from '../../../models/list-transaction.model';
import { TransactionSummaryModel } from '../../../models/transaction-summary.model';
import { TransactionModel } from '../../../models/transaction.model';
import { TransactionsResource } from '../../../services/resources/transactions.resource';

@Component({
    selector: 'sl-transactions-view',
    templateUrl: './transactions-view.component.html',
    styleUrls: ['./transactions-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TransactionsViewComponent extends BaseController<TransactionModel, TransactionSummaryModel, ListTransactionModel> {
    protected override readonly _entityResource = inject(TransactionsResource);

    get incomingRouterLink(): string {
        return `/${this.recordSummary()?.incomingAccountTypeIsBank ? 'traders' : 'shareholders'}/${this.recordSummary()?.incomingId ?? ''}`;
    }

    get outgoingRouterLink(): string {
        return `/${this.recordSummary()?.outgoingAccountTypeIsBank ? 'traders' : 'shareholders'}/${this.recordSummary()?.outgoingId ?? ''}`;
    }
}
